import { TYPE } from '@com-delta-idp/mnx-skymiles-overview';
import {
  MedallionAriaLabel,
  TierType,
  UserSession
} from '@com-delta-idp/mnx-skymiles-shared';
import { Link } from '@com-delta-idp/mnx-ui-kit';
import {
  MedallionBannerAriaLabel,
  Priority
} from '@com-delta-omnichannel/aura';
import {
  MedallionBannerDetails,
  MedallionItem,
  SalutationItem
} from '../models';

export const getMedallionItemAction = (
  medallionItem: MedallionItem,
  is360Tier: boolean
): Link => {
  return {
    label: medallionItem.medallionBenefitMessage,
    url: is360Tier
      ? medallionItem.medallionBenefit360Url
      : medallionItem.medallionBenefitUrl
  };
};

export const getSalutationMessage = (
  medallionBannerDetails: MedallionBannerDetails
): string => {
  if (medallionBannerDetails.salutationCards.salutation) {
    return getWelcomeMessage(medallionBannerDetails.salutationCards.salutation);
  }
  return '';
};

export const getWelcomeMessage = (salutation: SalutationItem[]): string => {
  const hours = new Date().getHours();
  let welcomeMessage: string = salutation[2].salutationLabel;

  if (hours < 12) {
    welcomeMessage = salutation[0].salutationLabel;
  } else if (hours >= 12 && hours <= 17) {
    welcomeMessage = salutation[1].salutationLabel;
  }
  return welcomeMessage;
};

export const getTierSubtitle = (
  medallionBannerDetails: MedallionBannerDetails,
  profile: UserSession,
  index: number
): string => {
  const medallionLabel =
    medallionBannerDetails.medallionDetails.medallion[
      index
    ].medallionLabel.toUpperCase();
  if (profile.is360Tier) {
    return `${medallionBannerDetails.label360
      .replace('&deg;', TYPE.DEGREE)
      .toUpperCase()}${medallionLabel}${medallionBannerDetails.trademark}`;
  }
  return profile.membershipLevel === 'FF'
    ? medallionLabel
    : `${medallionLabel}${medallionBannerDetails.trademark}`;
};

export const getTierName = (
  medallionBannerDetails: MedallionBannerDetails,
  profile: UserSession,
  index: number
): TierType => {
  if (profile.is360Tier) {
    return medallionBannerDetails.label360
      .replace('°', '')
      .split('&')[0]
      .split(' ')[1] as TierType;
  }
  return medallionBannerDetails.medallionDetails.medallion[index].medallionLabel
    .replace('®', '')
    .toLowerCase()
    .split(' ')[0] as TierType;
};

export const getSkyPriority = (
  medallionBannerDetails: MedallionBannerDetails,
  profile: UserSession
): Priority => {
  return profile.skyPriority
    ? {
        label: medallionBannerDetails.priority.label,
        url: medallionBannerDetails.priority.url,
        active: profile.skyPriority
      }
    : {
        label: '',
        url: '',
        active: profile.skyPriority
      };
};

export const getName = (profile: UserSession): string => {
  return profile.preferredName ? profile.preferredName : profile.firstName;
};
export const getMedallionBannerAriaLabel = (
  ariaLabel: MedallionAriaLabel,
  medallionMemberLevel: string
): MedallionBannerAriaLabel => {
  return {
    skyPriority: ariaLabel.skyPriorityLabel,
    level:
      ariaLabel.level +
      ' ' +
      medallionMemberLevel +
      ' ' +
      ariaLabel.millionMiler
  };
};
